module.exports = __webpack_public_path__ + "img/NewUI-NJLSLogo.45c1687e.png";